export default "__VITE_PUBLIC_ASSET__cdb70091__"